import { createReducer } from 'redux-create-reducer';
import callAPI from '../../../utils/callAPI';
import { TypeMarket } from '../../../constant/goldbar';

// export const ACTION_FETCH_COUNTRIES = 'ACTION_FETCH_COUNTRIES';
export const REQUEST_FETCH_GOLDBAR = 'REQUEST_FETCH_GOLDBAR';
export const REQUEST_FETCH_GOLDBAR_SUCCESS = 'REQUEST_FETCH_GOLDBAR_SUCCESS';
export const REQUEST_FETCH_GOLDBAR_FAILURE = 'REQUEST_FETCH_GOLDBAR_FAILURE';

export const ACTION_SELECT_MARKET_TYPE = 'ACTION_SELECT_MARKET_TYPE';
export const ACTION_RESET_TO_DEFAULT = 'ACTION_RESET_TO_DEFAULT';

const defaultState = {
  goldbars: [],
  typeMarket: TypeMarket.QR,
  isFetchingGoldBar: false,
  isFetchGoldBarSuccess: false,
  isFetchGoldBarFailure: false,
};

const reducer = createReducer(defaultState, {
  [REQUEST_FETCH_GOLDBAR]: (state, _action) => ({
    ...state,
    isFetchingGoldBar: true,
    isFetchGoldBarSuccess: false,
    isFetchGoldBarFailure: false,
  }),
  [REQUEST_FETCH_GOLDBAR_SUCCESS]: (state, action) => ({
    ...state,
    goldbars: action?.payload?.data.items || [],
    isFetchingGoldBar: false,
    isFetchGoldBarSuccess: true,
    isFetchGoldBarFailure: false,
  }),
  [REQUEST_FETCH_GOLDBAR_FAILURE]: (state) => ({
    ...state,
    isFetchingGoldBar: false,
    isFetchGoldBarSuccess: false,
    isFetchGoldBarFailure: true,
  }),

  [ACTION_SELECT_MARKET_TYPE]: (state, action) => {
    console.log(action);

    return ({
      ...state,
      typeMarket: action.payload.type,
      marketPoint: action.payload.points,
      maxPerPerson: action.payload.maxPerPerson
    })
  },

  [ACTION_RESET_TO_DEFAULT]: () => {
    return { ...defaultState };
  },

});

export default reducer;
export const namespace = 'goldbar';

export const actionSelectMarket = (payload) => ({
  type: ACTION_SELECT_MARKET_TYPE,
  payload,
});

export const resetMarketState = (payload) => ({
  type: ACTION_RESET_TO_DEFAULT,
  payload,
});

export const fetchGoldBarAPI = (filter) => async (dispatch, getState) => {
  return await callAPI({
    method: 'get',
    apiPath: '/goldbar',
    actionTypes: [
      REQUEST_FETCH_GOLDBAR,
      REQUEST_FETCH_GOLDBAR_SUCCESS,
      REQUEST_FETCH_GOLDBAR_FAILURE,
    ],
    variables: {
      ...filter,
    },
    dispatch,
    getState,
  });
};